<template>
	<div class="row dynvibeRow" style="margin-top: 20px">
		<div class="col-lg-3 col-xs-12">
			<div class="dynvibeBox" style="min-height: 100px">
				<div v-if="loading" class="dynvibeLoading"></div>
				<div v-if="!loading">
					<span style="font-size: 16px; font-weight: 700; color: #23056b; text-transform: uppercase">Number of profiles</span>
					<br />
					<span class="dynvibeProfilesDetailsValue">{{ nbProfiles }}</span>
				</div>
			</div>
		</div>
		<div class="col-lg-3 col-xs-12">
			<div class="dynvibeBox" style="min-height: 100px">
				<div v-if="loading" class="dynvibeLoading"></div>
				<div v-if="!loading">
					<span style="font-size: 16px; font-weight: 700; color: #ef402e; text-transform: uppercase">Number of Posts</span>
					<br />
					<span class="dynvibeProfilesDetailsValue">{{ nbPosts }}</span>
				</div>
			</div>
		</div>
		<div class="col-lg-3 col-xs-12">
			<div class="dynvibeBox" style="min-height: 100px">
				<div v-if="loading" class="dynvibeLoading"></div>
				<div v-if="!loading">
					<span style="font-size: 16px; font-weight: 700; color: #ef402e; text-transform: uppercase">Average Growth</span>
					<br />
					<span class="dynvibeProfilesDetailsValue">{{ Math.round(avgGrowth) }}%</span>
				</div>
			</div>
		</div>
		<div class="col-lg-3 col-xs-12">
			<div class="dynvibeBox" style="min-height: 100px">
				<div v-if="loading" class="dynvibeLoading"></div>
				<div v-if="!loading">
					<span style="font-size: 16px; font-weight: 700; color: #23056b; text-transform: uppercase">Period Growth</span>
					<br />
					<span class="dynvibeProfilesDetailsValue">
						{{ Math.round(periodGrowth) }}%
						<img v-if="fire" style="width: 40px" class="flame-img" src="/img/flame.png" />
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "exploreNumbers",
	emits: ["nodata"],
	props: {
		type: {
			type: String,
			default: "",
		},
		panel: {
			type: String,
			default: "",
		},
		segment: {
			type: String,
			default: "",
		},
		date: {
			type: Object,
			default: function () {
				return {};
			},
		},
		country: {
			type: Array,
			default: function () {
				return [];
			},
		},
		sources: {
			type: Array,
			default: function () {
				return [];
			},
		},
		age: {
			type: Array,
			default: function () {
				return [];
			},
		},
		gender: {
			type: Array,
			default: function () {
				return [];
			},
		},
		category: {
			type: String,
			default: "",
		},
		subcategory: {
			type: String,
			default: "",
		},
		mastertag: {
			type: String,
			default: "",
		},
		trend: {
			type: String,
			default: "",
		},
		typemastertag: {
			type: String,
			default: "All",
		},
	},
	data() {
		return {
			nbProfiles: 0,
			nbPosts: 0,
			avgGrowth: 0,
			periodGrowth: 0,
			fire: false,
			loading: true,
		};
	},
	mounted() {},
	methods: {
		checkFilters() {
			if (this.date.gte === "") {
				return;
			}
			/*let level = "categories";
			if (this.category != "") {
				level = "subcategories";
			}
			if (this.subcategory != "" || this.mastertag != "") {
				level = "mastertag";
			}
			if (this.trend != "") {
				level = "trends";
			}*/
			this.hidden = false;
			this.loading = true;

			this.getData("numbers", {
				parameters: {
					panel: this.panel,
					segment: this.segment,
					date: this.date,
					country: this.country,
					category: this.category,
					subcategory: this.subcategory,
					mastertag: this.mastertag,
					trend: this.trend,
					typemastertag: this.typemastertag,
					age: this.age,
					gender: this.gender,
					sources: this.sources,
				},
			});
		},
		loadComponent(/*parameters*/) {
			this.loading = true;
			this.getData("numbers", {
				parameters: {
					panel: this.panel,
					segment: this.segment,
					date: this.date,
					country: this.country,
					category: this.category,
					subcategory: this.subcategory,
					mastertag: this.mastertag,
					trend: this.trend,
					typemastertag: this.typemastertag,
					age: this.age,
					gender: this.gender,
					sources: this.sources,
				},
			});
		},
		treatResponse(response) {
			this.nbProfiles = response.data.nbProfiles;
			this.nbPosts = response.data.nbPosts;
			this.avgGrowth = response.data.avgGrowth;
			this.avgGrowth = Math.round(this.avgGrowth * 100) / 100;
			this.periodGrowth = response.data.periodGrowth;
			this.fire = this.periodGrowth > 100;
			this.loading = false;
			if (this.nbPosts === 0) {
				// no post, global no data to display
				this.$emit("nodata");
			}
		},
	},
	watch: {
		panel() {
			this.checkFilters();
		},
		segment() {
			this.checkFilters();
		},
		date: {
			deep: true,
			handler() {
				this.checkFilters();
			},
		},
		country() {
			this.checkFilters();
		},
		category() {
			this.checkFilters();
		},
		subcategory() {
			this.checkFilters();
		},
		mastertag() {
			this.checkFilters();
		},
	},
};
</script>

<style></style>
